import type { UseFormReturn } from "react-hook-form"
import LoanPaymentActions from "./loan/actions"
import SelfPaymentActions from "./self/actions"
import { usePayment } from "./use-payment"
import { type FIELD } from "@/types/form-types"
import OfflinePaymentActions from "./offline/actions"

const Actions = ({
	form,
	config,
	programTypeFieldId,
	periodNumber,
}: {
	form: UseFormReturn
	config: FIELD
	programTypeFieldId: string
	periodNumber: number
}) => {
	const { formState } = usePayment()
	const renderActions = () => {
		if (
			(formState?.self_payment_mode === "already-paid" &&
				formState?.payment_type === "self") ||
			(formState?.loan_payment_mode === "loan-disbursed" &&
				formState?.payment_type === "loan")
		) {
			return <OfflinePaymentActions periodNumber={periodNumber} />
		}
		switch (formState?.payment_type) {
			case "self":
				return (
					<SelfPaymentActions
						form={form}
						config={config}
						programTypeFieldId={programTypeFieldId}
					/>
				)
			case "loan":
				return (
					<LoanPaymentActions
						periodNumber={periodNumber}
						form={form}
						status={form.watch(config.field_id)?.payment_status}
					/>
				)
			default:
				return null
		}
	}
	return <div>{renderActions()}</div>
}

export default Actions
